export default __webpack_public_path__ + "ee04b5e8fe294dfbee327c909fe3fdec.png";